import React, { useState } from "react";
import "./MLRJSCDetailReview.styles.scss";
import Modal from "react-modal";
import { connect, useSelector } from "react-redux";
import { rjscDetailReviewSelect } from "../../redux/selector/rjscSearchSelector";
import { setCompanyRjscDetails } from "../../redux/slice/rjscDetailReviewSlice";
import {
  Header,
  Paragraph,
  Button,
  SubHeader,
  LineSeperator,
} from "../../components/RegularComponents";
import { push } from "connected-react-router";
import TopNavigationBar from "../TopNavigationBar";
import {
  APPLICATION_MODE_NEW,
  APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE,
  LICENCE_SUB_TYPE_MORTGAGE_LENDER_NEW_APPLICATION,
  RJSC_UPDATE_LINK,
  ROUTE_PATH,
} from "../../app/constants";
import ReviewForm from "../../components/ReviewForm/ReviewForm";
import { ERROR_STRING } from "../../app/errors";
import CheckBoxForm from "../../components/CheckBoxForm";
import { saveBusinessLicenceApplicationData } from "../../redux/slice/businessLicenceApplicationSlice";
import { applicationTypeFromLicenceSubType } from '../../redux/slice/applicationsUtils'

const MLRJSCDetailReview = (props) => {
  const { rjscDetailReview, dispatch } = props;

  const [showUpdateRjscDetailDialog, setShowUpdateRsjcDetailDialog] =
    useState(false);
  const [showCompanyNotActiveError, setShowCompanyNotActiveError] =
    useState(false);
  const [showSaveApplicationError, setShowSaveApplicationError] =
    useState(false);

  const [complianceOfficerAvailableInList, setComplianceOfficerAvailableInList] =
    useState(false);
  
  const { licencingSubType } = useSelector((state) => ({
    licencingSubType : state.primaryAgencyApplication.application?.licencingSubType ?? LICENCE_SUB_TYPE_MORTGAGE_LENDER_NEW_APPLICATION,
  }));

  const applicationType = applicationTypeFromLicenceSubType(licencingSubType);

  const onSaveNextClick = () => {
    if (rjscDetailReview.companyRjscData?.status === "ACTIVE") {
      dispatch(setCompanyRjscDetails(rjscDetailReview.companyRjscData));
      dispatch(
        saveBusinessLicenceApplicationData(
          applicationType,
          APPLICATION_MODE_NEW
        )
      )
        .then((data) => {
          const nextRoutePath = (applicationType === APPLICATION_TYPE_MORTGAGE_LENDER_LICENCE) ? 
                  ROUTE_PATH.ML_APP : ROUTE_PATH.MA_APP
          dispatch(
            push(`${nextRoutePath}${ROUTE_PATH.ML_NEXT_STEPS}`)
          );
        })
        .catch((err) => {
          setShowSaveApplicationError(true);
        });
    } else {
      // show an error message explaining the problem
      setShowCompanyNotActiveError(true);
    }
  };

  const onUpdateInfoClick = () => {
    setShowUpdateRsjcDetailDialog(true);
  };

  const anyError = () => {
    return showCompanyNotActiveError || showSaveApplicationError;
  };

  const errorString = () => {
    if (showCompanyNotActiveError) {
      return ERROR_STRING.RJSC_STATUS_NOT_ACTIVE;
    }

    if (showSaveApplicationError) {
      return ERROR_STRING.APPLICATION_SAVE_ERROR;
    }

    return "Error";
  };

  return (
    <>
      <div className={"container"}>
        <TopNavigationBar 
              {...props} 
              applicationType={applicationType} 
              applicationMode={APPLICATION_MODE_NEW} />
        <div className="row">
          <div className="col-lg-8">
            <Header
              id="rjsc-detail-review-header"
              header={"Confirm business information"}
            />
            <Paragraph
              id="rjsc-detail-review-text"
              text={[
                'If your business information is out of date, you must update it with the <a style="text-decoration: underline" href="https://rjsc.novascotia.ca/" target="_blank">Registry of Joint Stock Companies (RJSC)</a> before you continue your application.',
              ]}
            />
          </div>
        </div>

        <div className="row bottomMarginNormal">
          <div className="col-lg-8">
            <SubHeader subHeader={"Company information"} />
            <ReviewForm data={rjscDetailReview.companyReview} fullSize={true} />

            <LineSeperator
              style={{ borderColor: "#777", borderWidth: "2px" }}
            />

            <SubHeader subHeader={"Individuals listed under RJSC"} />
            <div className="companyPeopleReviewForm">
              {rjscDetailReview.peopleReview
                ? rjscDetailReview.peopleReview.map((people) => {
                    return (
                      <div className="companyPeopeReviewFormItem">
                        <ReviewForm data={people} />
                      </div>
                    );
                  })
                : null}
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-8">
            <LineSeperator
              style={{ borderColor: "#777", borderWidth: "2px" }}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-lg-8">
            <h3>Compliance Officer must be one of the individuals above.</h3>
            <p>
              You as the Compliance Officer for your company, have to be listed as a
              director, partner, officer, or sole proprietor with the Registry
              of Joint Stock Companies. If your name isn't on the list, you
              will need to update your company's profile on RJSC.
            </p>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-8">
            <CheckBoxForm
              id="compliance-officer-in-list-checkbox"
              checked={complianceOfficerAvailableInList}
              value={complianceOfficerAvailableInList}
              labelText="Yes, my name is on the list"
              onCheckBoxChange={(val) => {
                setComplianceOfficerAvailableInList(val);
              }}
            />
          </div>
        </div>

        <div className="row topMarginNormal">
          <div className="col-auto">
            <div className={anyError() ? " has-error" : ""}>
              <div className="help-block">
                <Button
                  disabled={!complianceOfficerAvailableInList}
                  id={"rjsc-detail-save-next"}
                  text={"Save and next"}
                  buttonType={"regular_primary"}
                  onClick={onSaveNextClick}
                />
                {anyError() && (
                  <span style={{ marginLeft: "5px" }}>
                    <i
                      className="fa fa-exclamation-circle"
                      aria-hidden="true"
                    ></i>
                  </span>
                )}
              </div>
            </div>
          </div>
          <div className="col-auto">
            <Button
              id={"rjsc-detail-update-info"}
              text={"Update outdated information in RJSC"}
              buttonType={"regular_primary"}
              onClick={onUpdateInfoClick}
              className="btn ns-btn-2nd"
            />
          </div>
        </div>

        {anyError() && (
          <div className="row">
            <div className="col-lg-12 topMarginNormal">
              <div className="has-error">{errorString()}</div>
            </div>
          </div>
        )}

        <Modal
          appElement={document.getElementById("root")}
          isOpen={showUpdateRjscDetailDialog}
          contentLabel="rjscDetailUpdateDialog"
          onRequestClose={() => {}}
          shouldCloseOnEsc={false}
          shouldCloseOnOverlayClick={false}
          className="modalDialogContent updateRjscDetailDialog"
          closeTimeoutMS={150}
        >
          <div className="row pull-right">
            <div
              className="col-lg-1 closeButton"
              onClick={() => {
                setShowUpdateRsjcDetailDialog(false);
              }}
            >
              <i className="fa fa-2x fa-times"></i>
            </div>
          </div>
          <Header header={rjscDetailReview.updateRjscDetailDialog.header} />
          <p
            dangerouslySetInnerHTML={{
              __html: rjscDetailReview.updateRjscDetailDialog.htmlText,
            }}
          ></p>
          <a
            className={"btn btn-primary"}
            href={RJSC_UPDATE_LINK}
            target={"_blank"}
            rel={"noreferrer"}
            id={"update-rjsc-anchor"}
            style={{ marginTop: "20px" }}
          >
            {"Continue to RJSC"}
          </a>
        </Modal>
      </div>
    </>
  );
};

export default connect(rjscDetailReviewSelect)(MLRJSCDetailReview);
